import { Injectable, Inject } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { HUB_API_SETTINGS_TOKEN } from '../../hub-api-settings-token';
import { HubApiSettingsService } from '../../hub-api-settings.service';

import { CreateEditCompanyContactCommand } from '../model/command/create-edit-company-contact-command';
import { CreateEditBccContractContactCommand } from '../model/command/create-edit-bcc-contract-contact-command';
import { CreateContractContactCommand } from '../model/command/create-contract-contact-command';
import { EditContractInspectionStatusCommand } from '../model/command/edit-contract-inspection-status-command';
import { EditContractCommand } from '../model/command/edit-contract-command';
import { EditContractContactCommand } from '../model/command/edit-contract-contact-command';
import { CreateItemWebConsoleCommand } from '../model/command/create-item-web-console-command';
import { CreateQuoteWebConsoleCommand } from '../model/command/create-quote-web-console-command';
import { EditItemWebConsoleCommand } from '../model/command/edit-item-web-console-command';
import { EditQuoteWebConsoleCommand } from '../model/command/edit-quote-web-console-command';
import { CreateContractCommand } from '../model/command/create-contract-command';

/* Copyright CADS
 *
 * All rights are reserved. Reproduction or transmission in whole or in part, in
 * any form or by any means, electronic, mechanical or otherwise, is prohibited
 * without the prior written consent of the copyright owner.
 *
 * THIS FILE IS AUTO GENERATED DO NOT EDIT IT MANULLY
 *
 */

// Generated service for sending Contract commands to the API.
@Injectable()
export class ContractCommandService {

  constructor(
    private http: HttpClient,
    private settingsService: HubApiSettingsService,
  ) { }

  CreateEditCompanyContactCommand(commandData: CreateEditCompanyContactCommand): Observable<any> {
    const token = this.settingsService.getAccessToken();
    const url = `${this.settingsService.getApiServiceBaseUrl()}webCommand/processWebCommand`;
    const options = {
       headers: new HttpHeaders(
        {
          'Content-Type': 'application/json; charset=utf-8',
          'Authorization': `Bearer ${token}`
        }),
      body: {
        'CommandData': JSON.stringify(commandData),
        'CommandType': 'Cads.SmartScaffolder.Hub.Business.Commands.Contract.CreateEditCompanyContactCommand'
      },
    };
    return this.http.request('POST', url, options);
  }

  CreateEditBccContractContactCommand(commandData: CreateEditBccContractContactCommand): Observable<any> {
    const token = this.settingsService.getAccessToken();
    const url = `${this.settingsService.getApiServiceBaseUrl()}webCommand/processWebCommand`;
    const options = {
       headers: new HttpHeaders(
        {
          'Content-Type': 'application/json; charset=utf-8',
          'Authorization': `Bearer ${token}`
        }),
      body: {
        'CommandData': JSON.stringify(commandData),
        'CommandType': 'Cads.SmartScaffolder.Hub.Business.Commands.Contract.CreateEditBccContractContactCommand'
      },
    };
    return this.http.request('POST', url, options);
  }

  CreateContractContactCommand(commandData: CreateContractContactCommand): Observable<any> {
    const token = this.settingsService.getAccessToken();
    const url = `${this.settingsService.getApiServiceBaseUrl()}webCommand/processWebCommand`;
    const options = {
       headers: new HttpHeaders(
        {
          'Content-Type': 'application/json; charset=utf-8',
          'Authorization': `Bearer ${token}`
        }),
      body: {
        'CommandData': JSON.stringify(commandData),
        'CommandType': 'Cads.SmartScaffolder.Hub.Business.Commands.Contract.CreateContractContactCommand'
      },
    };
    return this.http.request('POST', url, options);
  }

  EditContractInspectionStatusCommand(commandData: EditContractInspectionStatusCommand): Observable<any> {
    const token = this.settingsService.getAccessToken();
    const url = `${this.settingsService.getApiServiceBaseUrl()}webCommand/processWebCommand`;
    const options = {
       headers: new HttpHeaders(
        {
          'Content-Type': 'application/json; charset=utf-8',
          'Authorization': `Bearer ${token}`
        }),
      body: {
        'CommandData': JSON.stringify(commandData),
        'CommandType': 'Cads.SmartScaffolder.Hub.Business.Commands.Contract.EditContractInspectionStatusCommand'
      },
    };
    return this.http.request('POST', url, options);
  }

  EditContractCommand(commandData: EditContractCommand): Observable<any> {
    const token = this.settingsService.getAccessToken();
    const url = `${this.settingsService.getApiServiceBaseUrl()}webCommand/processWebCommand`;
    const options = {
       headers: new HttpHeaders(
        {
          'Content-Type': 'application/json; charset=utf-8',
          'Authorization': `Bearer ${token}`
        }),
      body: {
        'CommandData': JSON.stringify(commandData),
        'CommandType': 'Cads.SmartScaffolder.Hub.Business.Commands.Contract.EditContractCommand'
      },
    };
    return this.http.request('POST', url, options);
  }

  EditContractContactCommand(commandData: EditContractContactCommand): Observable<any> {
    const token = this.settingsService.getAccessToken();
    const url = `${this.settingsService.getApiServiceBaseUrl()}webCommand/processWebCommand`;
    const options = {
       headers: new HttpHeaders(
        {
          'Content-Type': 'application/json; charset=utf-8',
          'Authorization': `Bearer ${token}`
        }),
      body: {
        'CommandData': JSON.stringify(commandData),
        'CommandType': 'Cads.SmartScaffolder.Hub.Business.Commands.Contract.EditContractContactCommand'
      },
    };
    return this.http.request('POST', url, options);
  }

  CreateItemWebConsoleCommand(commandData: CreateItemWebConsoleCommand): Observable<any> {
    const token = this.settingsService.getAccessToken();
    const url = `${this.settingsService.getApiServiceBaseUrl()}webCommand/processWebCommand`;
    const options = {
       headers: new HttpHeaders(
        {
          'Content-Type': 'application/json; charset=utf-8',
          'Authorization': `Bearer ${token}`
        }),
      body: {
        'CommandData': JSON.stringify(commandData),
        'CommandType': 'Cads.SmartScaffolder.Hub.Business.Commands.Contract.CreateItemWebConsoleCommand'
      },
    };
    return this.http.request('POST', url, options);
  }

  CreateQuoteWebConsoleCommand(commandData: CreateQuoteWebConsoleCommand): Observable<any> {
    const token = this.settingsService.getAccessToken();
    const url = `${this.settingsService.getApiServiceBaseUrl()}webCommand/processWebCommand`;
    const options = {
       headers: new HttpHeaders(
        {
          'Content-Type': 'application/json; charset=utf-8',
          'Authorization': `Bearer ${token}`
        }),
      body: {
        'CommandData': JSON.stringify(commandData),
        'CommandType': 'Cads.SmartScaffolder.Hub.Business.Commands.Contract.CreateQuoteWebConsoleCommand'
      },
    };
    return this.http.request('POST', url, options);
  }

  EditItemWebConsoleCommand(commandData: EditItemWebConsoleCommand): Observable<any> {
    const token = this.settingsService.getAccessToken();
    const url = `${this.settingsService.getApiServiceBaseUrl()}webCommand/processWebCommand`;
    const options = {
       headers: new HttpHeaders(
        {
          'Content-Type': 'application/json; charset=utf-8',
          'Authorization': `Bearer ${token}`
        }),
      body: {
        'CommandData': JSON.stringify(commandData),
        'CommandType': 'Cads.SmartScaffolder.Hub.Business.Commands.Contract.EditItemWebConsoleCommand'
      },
    };
    return this.http.request('POST', url, options);
  }

  EditQuoteWebConsoleCommand(commandData: EditQuoteWebConsoleCommand): Observable<any> {
    const token = this.settingsService.getAccessToken();
    const url = `${this.settingsService.getApiServiceBaseUrl()}webCommand/processWebCommand`;
    const options = {
       headers: new HttpHeaders(
        {
          'Content-Type': 'application/json; charset=utf-8',
          'Authorization': `Bearer ${token}`
        }),
      body: {
        'CommandData': JSON.stringify(commandData),
        'CommandType': 'Cads.SmartScaffolder.Hub.Business.Commands.Contract.EditQuoteWebConsoleCommand'
      },
    };
    return this.http.request('POST', url, options);
  }

  CreateContractCommand(commandData: CreateContractCommand): Observable<any> {
    const token = this.settingsService.getAccessToken();
    const url = `${this.settingsService.getApiServiceBaseUrl()}webCommand/processWebCommand`;
    const options = {
       headers: new HttpHeaders(
        {
          'Content-Type': 'application/json; charset=utf-8',
          'Authorization': `Bearer ${token}`
        }),
      body: {
        'CommandData': JSON.stringify(commandData),
        'CommandType': 'Cads.SmartScaffolder.Hub.Business.Commands.Contract.CreateContractCommand'
      },
    };
    return this.http.request('POST', url, options);
  }
}
